import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-mitteilungs-vorlagen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungMitteilungsVorlagenEffects {

    VeranstaltungMitteilungsVorlagen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_MITTEILUNGS_VORLAGEN),
        mergeMap((x: ac.GetVeranstaltungMitteilungsVorlagenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungMitteilungsVorlagen(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungMitteilungsVorlagenErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungMitteilungsVorlagenFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungenQueryService);
        }
        return this.service;
    }
}
